import _ from 'lodash';
import {
  createStore,
  applyMiddleware,
  combineReducers,
} from 'redux';
import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';

export default function createStoreImpl(...reducers) {
  const rootReducer = combineReducers(
    reducers.reduce(
      (currentRoot, reducer) => _.assign(currentRoot, reducer),
      {},
    ),
  );
  const loggerMiddleware = createLogger();
  const middleware = applyMiddleware(thunkMiddleware, loggerMiddleware);
  return createStore(rootReducer, undefined, middleware);
}
